import React from "react";
import {
  Button,
  Transition,
  Grid,
  Form,
  Header,
  Radio
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  setConnection,
  checkCompatibility
} from "../../../store/actions/connection";

class Unknown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      units: null,
      years: null,
      location: null
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.handleChangeUnits = this.handleChangeUnits.bind(this);
    this.handleChangeYears = this.handleChangeYears.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(9, "fade right");
    }, 400);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  handleChangeUnits(e, { value }) {
    this.setState({
      units: value
    });
  }
  handleChangeYears(e, { value }) {
    this.setState({
      years: value
    });
  }
  handleChangeLocation(e, { value }) {
    this.setState({
      location: value
    });
  }

  continue() {
    const { changeStep, address } = this.props;
    const { units, years, location } = this.state;

    if (!(units && years && location)) {
      return;
    }

    const unit_count = units === "yes" ? 1 : 0;
    const building_age = years === "yes" ? 1 : 0;
    const loc = location === "yes" ? 1 : 0;

    this.setState({
      animation: "fade right",
      visible: false
    });
    this.props
      .checkCompatibility({ address, unit_count, building_age, location: loc })
      .then(res => {
        setTimeout(() => {
          changeStep(7, "fade left");
        }, 400);
      })
      .catch(error => {
        setTimeout(() => {
          changeStep(8, "fade left");
        }, 400);
      });
  }

  render() {
    const { visible, animation } = this.state;
    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div className="building-form">
            <Header className="title__main" as="h1" textAlign="center">
              Request FibreStream
            </Header>
            <Header.Subheader className="text-black">
              We need more information about your building to determine compatibility
            </Header.Subheader>
            <Form className="form check-address mt-7">
              <div className="mt-4">
                <Form.Field>My building has over 100 units </Form.Field>
                <Form.Field>
                  <Radio
                    label="Yes"
                    name="units"
                    value="yes"
                    checked={this.state.units === "yes"}
                    onChange={this.handleChangeUnits}
                  />
                  <Radio
                    label="No"
                    name="units"
                    value="no"
                    checked={this.state.units === "no"}
                    onChange={this.handleChangeUnits}
                  />
                </Form.Field>
              </div>

              <div className="mt-4">
                <Form.Field>
                  My building is less than 20 years old
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Yes"
                    name="years"
                    value="yes"
                    checked={this.state.years === "yes"}
                    onChange={this.handleChangeYears}
                  />
                  <Radio
                    label="No"
                    name="years"
                    value="no"
                    checked={this.state.years === "no"}
                    onChange={this.handleChangeYears}
                  />
                </Form.Field>
              </div>
              <div className="mt-4">
                <Form.Field>
                  My building is located in Toronto, Ottawa or Vancouver area
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Yes"
                    name="location"
                    value="yes"
                    checked={this.state.location === "yes"}
                    onChange={this.handleChangeLocation}
                  />
                  <Radio
                    label="No"
                    name="location"
                    value="no"
                    checked={this.state.location === "no"}
                    onChange={this.handleChangeLocation}
                  />
                </Form.Field>
              </div>
              <Grid className="mx-0 my-0">
                <Button
                  className="btn--full"
                  type="button"
                  size="medium"
                  onClick={this.continue.bind(this)}
                >
                  Continue
                </Button>
              </Grid>
            </Form>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setConnection: data => dispatch(setConnection(data)),
    checkCompatibility: data => dispatch(checkCompatibility(data))
  };
};

const mapStateToProps = state => {
  return {
    address: state.connection.address
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Unknown));



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Unknown.js